module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_esfiha.b4b9e52a.png";